import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import "chartjs-adapter-date-fns"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Array }

  connect() {
    const colors = {
      "Article": "rgba(249, 115, 22, 0.7)",
      "LinkedinJoke": "rgba(59, 130, 246, 0.7)"
    }

    const labels = {
      "Article": "Article",
      "LinkedinJoke": "Joke"
    }

    const allCounts = this.dataValue.flatMap(ds => ds.data.map(d => d.count))
    const maxCount = Math.max(...allCounts, 1)

    const datasets = this.dataValue.map(ds => ({
      label: labels[ds.type] || ds.type,
      data: ds.data.map(d => ({ x: d.x + "T00:00:00Z", y: d.y, count: d.count })),
      borderColor: colors[ds.type],
      backgroundColor: colors[ds.type],
      fill: false,
      tension: 0.3,
      borderDash: [5, 5],
      borderWidth: 2,
      pointRadius: (ctx) => Math.max(Math.sqrt((ctx.raw?.count || 1) / maxCount) * 30, 4),
      pointHoverRadius: (ctx) => Math.max(Math.sqrt((ctx.raw?.count || 1) / maxCount) * 30 + 2, 6)
    }))

    new Chart(this.canvasTarget, {
      type: "line",
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { bottom: 20 } },
        scales: {
          x: {
            type: "time",
            time: { unit: "week", tooltipFormat: "MMM d", displayFormats: { week: "MMM d" } },
            title: { display: true, text: "Week" }
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: "Avg views per post" }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (ctx) => {
                return `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} avg views (${ctx.raw.count} posts)`
              }
            }
          }
        }
      }
    })
  }
}
